import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { GradingPresence } from "../../types/grading/PendingCorrection";
import { AxiosError } from "axios";

/**
 * Live, non-blocking grading presence: the assessors currently grading an exam instance.
 */
export const useGetActiveGraders = (
  examInstanceId: string,
  options?: { enabled?: boolean; refetchInterval?: number }
) => {
  const axios = useAxios();

  return useQuery<GradingPresence>({
    queryKey: ["gradingActiveGraders", examInstanceId],
    queryFn: async () => {
      const response = await axios.get<GradingPresence>(
        `/api/grading/examinstances/${examInstanceId}/active-graders`
      );
      return response.data;
    },
    enabled: !!examInstanceId && options?.enabled !== false,
    retry: (failureCount, error) => {
      const status = (error as AxiosError)?.response?.status;
      if (status === 403) return false;
      return failureCount < 2;
    },
    refetchInterval: (query) => {
      const status = (query?.state?.error as AxiosError | null)?.response?.status;
      if (status === 403) return false;
      return options?.refetchInterval ?? 20000;
    },
  });
};

export default useGetActiveGraders;
